import { useCallback } from 'react';
import DrawerExtraButtons from 'components/DrawerExtraButtons';
import { getText } from 'i18n/intl';
import {
  availabilityCollectionPeriodsSelectedPeriodSelector,
  createAvailabilityCollectionPeriod,
  deleteAvailabilityCollectionPeriod,
  deleteUnsavePeriod,
  resetPeriodChanges,
  setSelectedPeriod,
  updateAvailabilityCollectionPeriod,
} from 'slices/availabilityCollectionPeriod.slice';
import { useAppDispatch, useAppSelector } from 'slices/store';
import { TEDrawer } from '@timeedit/ui-components';
import PeriodDetail from './PeriodDetail';

const PeriodDrawer = () => {
  const dispatch = useAppDispatch();
  const selectedPeriod = useAppSelector(
    availabilityCollectionPeriodsSelectedPeriodSelector
  );

  const onClose = () => dispatch(setSelectedPeriod(null));

  const onSave = useCallback(() => {
    if (selectedPeriod?.id !== 'new') {
      dispatch(updateAvailabilityCollectionPeriod());
    } else {
      dispatch(createAvailabilityCollectionPeriod());
    }
  }, [dispatch, selectedPeriod]);

  const onDelete = useCallback(() => {
    if (!selectedPeriod) return;
    if (selectedPeriod.id === 'new') {
      dispatch(deleteUnsavePeriod());
      return;
    }
    dispatch(deleteAvailabilityCollectionPeriod());
  }, [dispatch, selectedPeriod]);

  const onDiscard = useCallback(() => {
    if (!selectedPeriod) return;
    dispatch(resetPeriodChanges());
  }, [dispatch, selectedPeriod]);

  return (
    <TEDrawer
      expandWidth="50vw"
      firstDrawer={{
        title:
          (selectedPeriod?.name ?? '') === ''
            ? 'New Period'
            : selectedPeriod?.name,
        content: <PeriodDetail />,
        drawerOpen: !!selectedPeriod,
        extra: (
          <DrawerExtraButtons
            confirmDeleteMsg={getText('availability_collection.period.delete')}
            isDeleteDisable={selectedPeriod?.id === 'new'}
            handleDelete={onDelete}
            handleDiscard={onDiscard}
            handleSave={onSave}
            isSaveDisable={false}
          />
        ),
        setDrawerOpen: (open) => !open && onClose(),
      }}
    />
  );
};

export default PeriodDrawer;
